const cacheMap = new Map();

export default function cacheHandler(type, key, value, data) {
  if (!key || !value || !type) return;

  if (!cacheMap.has(key)) {
    cacheMap.set(key, new Map());
  }

  const keyMap = cacheMap.get(key);

  if (type === 'get') {
    return keyMap.get(value);
  }

  if (type === 'set') {
    keyMap.set(value, data);
  }

  return null;
}
